import React from "react"
import { Survey } from "../../../../domain/entities/Survey"
import { SurveysViewModel } from "../SurveysViewModel"
import { observer } from "mobx-react"
import SurveyUsersTable from "./SurveyUsersTable"

interface SurveyUsersCompletedSectionProps {
	survey: Survey
	viewModel: SurveysViewModel
}

const SurveyUsersCompletedSection: React.FC<SurveyUsersCompletedSectionProps> = ({ survey, viewModel }) => {
	return (
		<div>
			<SurveyUsersTable survey={survey} viewModel={viewModel} />
		</div>
	)
}

export default observer(SurveyUsersCompletedSection)
